import React from 'react';
import './style.scss';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import { CustomIcon } from '../../../../common';
import { ProviderProgressBar } from '../ProviderProgressBar';

export const TopProviders = ({ isDarkTheme }) => (
  <div className="top_providers">
    <div className="top_providers_header">
      <h2 className="top_providers_subtitle">Top 5 Providers</h2>
      <span>
        <CustomIcon
          src={isDarkTheme ? ARROW_BLUE : ARROW}
          width="8px"
          height="10px"
          rotate="270"
        />View all
      </span>
    </div>
    <ProviderProgressBar title="AT&T" percent={25} />
    <ProviderProgressBar title="Atlantic Broadband" percent={45} />
    <ProviderProgressBar title="Verizon" percent={50} />
    <ProviderProgressBar title="Sprint" percent={85} />
    <ProviderProgressBar title="Lorem" percent={5} />
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/TopProviders/index.js